module.exports = __webpack_public_path__ + "img/mobile-dl.05ac99a2.png";